import { useUserContextSelector } from '@/redux';
import {
  useGetUserTableSettingsQuery,
  useSetUserTableSettingsMutation,
} from '@/redux/clientSettings';
import { ColumnsType } from 'antd/lib/table';
import { ColumnState } from './ColumnMenuItem';
import { ColumnsDropdown } from './ColumnsDropdown';
import { selectHidden } from './columnSettingsUtils';
import { useColumnOptions } from './useColumnOptions';

export function useColumnsSelect<T>(
  table: string,
  columns?: ColumnsType<T>,
  defaultHiddenColumnKeys?: string[],
) {
  const userId = useUserContextSelector((x) => x.id);
  const { data, isFetching } = useGetUserTableSettingsQuery({
    userId,
    table,
  });
  const [updateSettings, { isLoading }] = useSetUserTableSettingsMutation();

  const { columnOptions, visibleColumns } = useColumnOptions(
    columns,
    data,
    defaultHiddenColumnKeys,
  );

  const handleColumnsChanged = (nextColumns: ColumnState[]) => {
    updateSettings({
      table,
      userId,
      hiddenColumns: selectHidden(nextColumns),
    });
  };

  return {
    columnsSelect: (
      <ColumnsDropdown value={columnOptions} onChange={handleColumnsChanged} />
    ),
    isLoading: isLoading || isFetching,
    visibleColumns,
  };
}
